import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import zhTW from 'date-fns/locale/zh-TW';
import { dateFilters } from '@components/DateFilter/constant/dateFilter';

const DateFilter = ({ defaultValue, data, setDefaultValue, updateData }) => {
    const [dateRange, setDateRange] = useState(['', '']);
    const [startDateCalendar, endDateCalendar] = dateRange;
    return (
        <div className="select-reason d-flex align-items-center">
            <div className="d-flex flex-nowrap align-sm-items-center mb-2 mb-sm-0 search-date">
                <select
                    className="col py-1 form-select rounded-pill cur-pointer mt-1"
                    required
                    value={defaultValue}
                    onChange={e => {
                        setDefaultValue(e.target.value);
                    }}
                >
                    {dateFilters.map(({ value, label }, idx) => {
                        return (
                            <option key={`dateFilter ${idx}`} value={value}>
                                {label}
                            </option>
                        );
                    })}
                </select>
                {defaultValue === '3' ? (
                    <div className="ps-1 mt-1">
                        <DatePicker
                            monthsShown={2}
                            dateFormat="yyyy/MM/dd"
                            locale={zhTW}
                            calendarStartDay={1}
                            selectsRange={true}
                            startDate={startDateCalendar}
                            endDate={endDateCalendar}
                            onChange={update => {
                                const dateRangeUpdate = update.map(item => {
                                    if (item) {
                                        return item;
                                    } else {
                                        return '';
                                    }
                                });
                                setDateRange(dateRangeUpdate);
                                const end = dateRangeUpdate[1]
                                    .toLocaleString('zh-TW')
                                    .split(' ')[0];
                                updateData(
                                    'startDate',
                                    dateRangeUpdate[0].toLocaleDateString()
                                );
                                updateData('endDate', end);
                            }}
                            shouldCloseOnSelect={false}
                            className="form-control rounded-pill border cur-pointer py-1"
                        />
                    </div>
                ) : null}
            </div>
            <span className={' fs-12 border-left d-none d-md-block ms-1'}>
                共 {data.length} 筆資料
            </span>
        </div>
    );
};

export default observer(DateFilter);
